import { render } from "./SurveyCustomer.vue?vue&type=template&id=0e85c222&scoped=true"
import script from "./SurveyCustomer.vue?vue&type=script&lang=js"
export * from "./SurveyCustomer.vue?vue&type=script&lang=js"

import "./SurveyCustomer.vue?vue&type=style&index=0&id=0e85c222&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e85c222"]])

export default __exports__